<template>
  <app-modal :modal-id="modalId"
             @confirm="confirm"
             @cancel="cancel"
  >
    <!-- Only a single member was selected -->
    <template v-if="memberIds && memberIds.length === 1">
      <p class="my-4">Are you sure you want to remove <strong>{{ memberIds[0] }}</strong>?</p>
    </template>
    <!-- Show list of members to remove, if provided -->
    <template v-else-if="memberIds && memberIds.length > 1">
      <div  class="row">
        <div class="col-12">
          <label :for="memberIds">Are you sure you want to remove the following members?</label>
          <div class="selected-members-row row scroll-container">
            <div v-for="(memberId) in memberIds" :key="memberId"
                 class="col-6 col-lg-4 selected-member">
              {{ memberId }}
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- Else show default message -->
    <template v-else>
      <p class="my-4">{{ defaultBody }}</p>
    </template>
  </app-modal>
</template>

<script>
import AppModal from './AppModal';

export default {
  name: 'RemoveMemberConfirmModal',
  components: {
    AppModal,
  },
  data() {
    return {
      defaultBody: 'Are you sure you want to remove the selected members?',
    };
  },
  props: {
    modalId: {
      type: String,
      required: true,
    },
    memberIds: {
      type: Array,
      required: false,
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    confirm() {
      this.$emit('confirm');
      this.$root.$emit('bv::hide::modal', this.modalId);
    },
  },
};
</script>

<style scoped>
  .selected-members-row {
    padding-left: 0.5em;
  }
  .selected-member {
    padding-bottom: 0.25em;
    opacity: 0.6;
  }
  .scroll-container {
    max-height: 100px;
    overflow-y: auto;
    margin-bottom: .5rem;
    margin-top: .5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/RemoveMemberConfirmModal.vue